import React from 'react';

interface TriStateToggleProps {
  value: boolean | null | undefined;
  onChange: (value: boolean | null) => void;
  disabled?: boolean;
}

const segments: { label: string; value: boolean | null }[] = [
  { label: 'Any', value: null },
  { label: 'No', value: false },
  { label: 'Yes', value: true },
];

const activeStyles: Record<string, string> = {
  null: 'bg-white text-gray-700 shadow-sm',
  false: 'bg-rose-100 text-rose-700 shadow-sm',
  true: 'bg-emerald-100 text-emerald-700 shadow-sm',
};

const TriStateToggle: React.FC<TriStateToggleProps> = ({ value, onChange, disabled = false }) => {
  const normalizedValue = value === undefined ? null : value;

  return (
    <div
      className={`inline-flex items-center rounded-full bg-gray-100 p-0.5 gap-0.5 ${
        disabled ? 'opacity-50' : ''
      }`}
    >
      {segments.map((segment) => {
        const isActive = normalizedValue === segment.value;
        const styleKey = String(segment.value);
        return (
          <button
            key={styleKey}
            type="button"
            disabled={disabled}
            onClick={() => onChange(segment.value)}
            className={`rounded-full px-2.5 py-0.5 text-xs font-medium transition-all duration-150 ${
              isActive
                ? activeStyles[styleKey]
                : 'text-gray-400 hover:text-gray-600'
            } ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
          >
            {segment.label}
          </button>
        );
      })}
    </div>
  );
};

export default TriStateToggle;
